// extracted by mini-css-extract-plugin
module.exports = {"tabPanel":"tabPanel__0yUHu"};